import React, { useState, useEffect } from "react";
import styles from "../styles/Pacientes.module.css";
import NuevoPacienteModal from "./NuevoPacienteModal";
import { fetchPacientes, fetchOwners, getOwnerName } from "../handlers/pacientes";

const Pacientes = () => {
  const [showModal, setShowModal] = useState(false);
  const [pacientes, setPacientes] = useState([]);
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("token");

  useEffect(() => {
    fetchPacientes(token, setPacientes, setLoading);
    fetchOwners(token, setOwners);
  }, [token, showModal]); // recarga al cerrar el modal

  return (
    <div className={styles.pacientesContainer}>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1rem" }}>
        <button
          className={styles.iconButton}
          title="Agregar nuevo paciente"
          onClick={() => setShowModal(true)}
        >
          ➕
        </button>
        <h3 className={styles.tituloPaciente}>🐾 Gestión de Pacientes</h3>
      </div>
      <NuevoPacienteModal show={showModal} onClose={() => setShowModal(false)} />
      {loading ? (
        <p>Cargando...</p>
      ) : pacientes.length === 0 ? (
        <p>No hay pacientes para mostrar.</p>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th className={styles.th}>Nombre</th>
              <th className={styles.th}>Especie</th>
              <th className={styles.th}>Raza</th>
              <th className={styles.th}>Edad</th>
              <th className={styles.th}>Chip</th>
              <th className={styles.th}>Propietario</th>
              <th className={styles.th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {pacientes.map((p) => (
              <tr key={p.id}>
                <td className={styles.td}>{p.name}</td>
                <td className={styles.td}>{p.species}</td>
                <td className={styles.td}>{p.breed}</td>
                <td className={styles.td}>{p.age}</td>
                <td className={styles.td}>{p.chip}</td>
                <td className={styles.td}>{getOwnerName(owners, p.owner_id)}</td>
                <td className={styles.td}>
                  {/* Aquí puedes agregar botones de editar/eliminar si lo necesitas */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Pacientes;